module.exports = __webpack_public_path__ + "media/application/images/external-services/woocommerce-logo-2f52635dd65e4d3c26c16fe5fe3da297.svg";